module.exports = __webpack_public_path__ + "assets/img/block-right-1b3352c0.png";